import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("vibe-cart-v2") || "[]");
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("vibe-cart-v2", JSON.stringify(items));
  }, [items]);

  const addItem = (product, quantity = 1) => {
    setItems((prev) => {
      const found = prev.find((i) => i.sku === product.sku);
      if (found) {
        return prev.map((i) =>
          i.sku === product.sku
            ? { ...i, quantity: Math.min(10, i.quantity + quantity) }
            : i
        );
      }
      return [
        ...prev,
        {
          sku: product.sku,
          name: product.name,
          price_paise: product.price_paise,
          sachets: product.sachets,
          image: product.image,
          quantity,
        },
      ];
    });
    setOpen(true);
  };

  const setQuantity = (sku, quantity) =>
    setItems((prev) =>
      quantity <= 0
        ? prev.filter((i) => i.sku !== sku)
        : prev.map((i) => (i.sku === sku ? { ...i, quantity: Math.min(10, quantity) } : i))
    );

  const removeItem = (sku) => setItems((prev) => prev.filter((i) => i.sku !== sku));
  const clear = () => setItems([]);

  const subtotalPaise = useMemo(
    () => items.reduce((sum, i) => sum + i.price_paise * i.quantity, 0),
    [items]
  );
  const count = useMemo(() => items.reduce((sum, i) => sum + i.quantity, 0), [items]);

  return (
    <CartContext.Provider
      value={{ items, addItem, setQuantity, removeItem, clear, subtotalPaise, count, open, setOpen }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
